'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  HOC that adds focused state to a component.
 *  Uses recompose to provide a component with the following props:
 *  - focused: Boolean of whether the component is focused or not
 *  - onFocus: Function that will set focused to true (will compose with existing onFocus if set)
 *  - onBlur: Function that will set focused to false (will compose with existing onBlur if set)
 */

/**
 * Add focused state and set focus
 */
var withFocusState = (0, _recompose.withState)('focused', 'withFocus__setFocus', false);

/**
 * Add onBlur and onFocus handlers.
 * Will call existing onBlur/onFocus handlers after
 * setting focused state if either are set.
 */
var withFocusHandlers = (0, _recompose.withHandlers)({
  onBlur: function onBlur(_ref) {
    var _onBlur = _ref.onBlur,
        withFocus__setFocus = _ref.withFocus__setFocus;
    return function () {
      withFocus__setFocus(false);

      // Call existing onBlur if set
      if (typeof _onBlur === 'function') {
        _onBlur.apply(undefined, arguments);
      }
    };
  },
  onFocus: function onFocus(_ref2) {
    var _onFocus = _ref2.onFocus,
        withFocus__setFocus = _ref2.withFocus__setFocus;
    return function () {
      withFocus__setFocus(true);

      // Call existing onFocus if set
      if (typeof _onFocus === 'function') {
        _onFocus.apply(undefined, arguments);
      }
    };
  }
});

// Strip the withState setFocus function
var removeSetFocus = (0, _recompose.mapProps)(function (_ref3) {
  var withFocus__setFocus = _ref3.withFocus__setFocus,
      rest = (0, _objectWithoutProperties3.default)(_ref3, ['withFocus__setFocus']);
  return rest;
}); // eslint-disable-line

var withFocus = (0, _recompose.compose)(withFocusState, withFocusHandlers, removeSetFocus);

exports.default = withFocus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/helpers/withFocus.js
// module id = 511
// module chunks = 0